//React
import { useNavigate } from "react-router-dom";
//CSS
import "./Header.css";
//LocalStorage
import SecureStorage from "react-secure-storage";
//Assets
import Logo from "../../assets/images/logo.svg";

const Header = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    SecureStorage.removeItem("isLoggedIn");

    const channel = new BroadcastChannel("auth-channel");
    channel.postMessage({ type: "LOGOUT" });
    channel.close();

    navigate("/login", { replace: true });
  };
  return (
    <div className="header-container">
      <div className="header-wrapper"
      onClick={() => {
        navigate("/home");
      }}
      >
        <Logo className="header-logo" alt="logo" />
        <div className="title">AI-FRESH</div>
      </div>
      <div className="logout-button" onClick={handleLogout}>
        Logout
      </div>
    </div>
  );
};

export default Header;
